export default "__VITE_ASSET__CYCtCwgr__$_?nuxt_component=async&nuxt_component_name=SvgoCommonNoDataDark&nuxt_component_export=default__"